import React from "react";
import { Stack, IconButton, Icon, Typography, Tabs, Tab } from "@mui/material";
import NewReadWebhookModal from "pages/SystemDash/component/ReadWebhook";
import getUserFriendlyDate from "common/utils/getUserFriendlyDate";
import WebhookView from "./WebhookView.js";
import useFetcher from "common/hooks/useFetcher";
import SidePanel from "common/components/SidePanel";
import { useParams } from "react-router-dom";
import { MiniLoader } from "common/components/Loader";
import Switch from "common/components/Switch";
import useConfirm from "common/hooks/useConfirm";
import ActionButton from "common/components/ActionButton";
import Log from "pages/Archive/components/Logging/Log";
import awsCron from "common/utils/awsCron/index.js";
import ScheduleEdit from "./ScheduleEdit";
const Status = {
  completed: "check_circle",
  failed: "error",
  queued: "pending",
  running: "pending",
};

export default function JobsModal({
  command,
  system,
  open,
  setOpen,
  dataBacked,
  role,
}) {
  const fetcher = useFetcher();
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [schedules, setSchedules] = React.useState([]);
  const [hooks, setHooks] = React.useState([]);
  const [job, setJob] = React.useState(null);
  const [view, setView] = React.useState(0);
  const { id: paramId, action } = useParams();
  let id = system || paramId;
  //if action exists, filter jobs, schedules, webhooks by it
  let filterByAction = (items) =>
    action ? items.filter((i) => i?.content?.action === action) : items;
  const deleteSchedule = async (job) => {
    await fetcher.delete(
      "deleting schedule",
      `/api/sys/${system}/schedule/${job}`,
      ({ success, error }) => {
        if (error) return;
        setJob(null);
        getSchedules();
      },
      () => {}
    );
  };
  const getJobs = async () => {
    setLoading(true);
    // const res = await fetcher.get(`/api/sys/${system.id}/jobs`);
    await fetcher.get(
      "fetching system jobs",
      `/api/sys/${id}/jobs`,
      ({ jobs }) => {
        try {
          let data = jobs.map((j) => ({ ...j, ...j.content }));
          setData(
            filterByAction(
              data.sort((a, b) => {
                // Convert string dates into `Date` objects
                const dateA = new Date(a.start.split("_")[0]);
                const dateB = new Date(b.start.split("_")[0]);

                // Subtract dateB from dateA to sort in descending order
                return dateB - dateA;
              })
            )
          );
          setLoading(false);
        } catch {
          setData([]);
          setLoading(false);
        }
      },
      () => {}
    );
  };
  const getSchedules = async () => {
    // const res = await fetcher.get(`/api/sys/${system.id}/jobs`);
    setLoading(true);
    await fetcher.get(
      "fetching system schedules",
      `/api/sys/${id}/schedules`,
      ({ schedules }) => {
        let data = schedules.map((j) => ({
          ...j,
          ...j.content,
        }));
        try {
          setSchedules(filterByAction(data));
          setLoading(false);
        } catch {
          setSchedules([]);
          setLoading(false);
        }
      },
      () => {
        setLoading(false);
      }
    );
  };
  const getHooks = async () => {
    await fetcher.get(
      "fetching system hook",
      `/api/sys/${id}/hooks`,
      ({ hooks }) => {
        try {
          setHooks(filterByAction(hooks));
        } catch (e) {
          console.log(e);
          setHooks([]);
        }
      },
      () => {}
    );
  };
  const deleteHook = async (hook) => {
    await fetcher.delete(
      "deleting hook",
      `/api/sys/${id}/hook/${hook}`,
      ({ success, error }) => {
        if (error) return;
        getHooks();
      },
      () => {}
    );
  };

  React.useEffect(() => {
    if (!open) return;
    view === 0 ? getJobs() : view === 1 ? getSchedules() : getHooks();
  }, [open, view]);

  const Webhooks = () => {
    const [webhook, setWebhook] = React.useState(false);
    const [systemReadUrl, setSystemReadUrl] = React.useState(false);
    const [openDeleteModal, DeleteModal] = useConfirm({
      title: `Delete Webhook`,
      message: `Are you sure you want to delete this webhook? This action can't be undone.`,
      callback: (props, context) => {
        deleteHook(context?.pk);
      },
    });
    if (["operator", "auditor"].includes(role)) return null;
    return (
      <Stack p={2}>
        <NewReadWebhookModal
          open={systemReadUrl}
          setOpen={setSystemReadUrl}
          refresh={getHooks}
          system={id}
        />
        <DeleteModal />
        {dataBacked ? (
          <div style={{ marginLeft: "auto" }}>
            <ActionButton
              dark
              icon="webhook"
              noload
              handler={async () => setSystemReadUrl(true)}
            >
              Create Read Webhook
            </ActionButton>
          </div>
        ) : null}
        <Stack p={2}>
          <SidePanel
            width={600}
            open={!!webhook}
            closeDrawer={() => setWebhook(false)}
            props={{ hook: webhook, system: id }}
          >
            {WebhookView}
          </SidePanel>
          {hooks?.length ? (
            (hooks || []).map((item, index) => {
              return (
                <Stack
                  key={index}
                  sx={{ width: "98%", margin: "0 auto" }}
                  direction="row"
                  alignItems={"center"}
                  p={2}
                  className="floating"
                >
                  <Stack sx={{ width: "100%" }}>
                    <Stack alignItems={"center"} direction="row" gap={1}>
                      <Icon>
                        {item?.type === "read" ? "bookmark" : "edit_note"}
                      </Icon>
                      <Typography>{item.name}</Typography>
                    </Stack>
                    <Stack gap={1}>
                      <Typography variant="caption">
                        {/* {item.content.cron} */}
                      </Typography>

                      <Typography variant="caption">
                        {/* {getNextCronTime(item?.content?.cron)} */}
                      </Typography>
                    </Stack>
                  </Stack>
                  <Stack direction="row" gap={1}>
                    <ActionButton
                      noload
                      circle
                      icon="navigate_next"
                      handler={() => {
                        setWebhook(item);
                      }}
                    />
                    <ActionButton
                      danger
                      noload
                      circle
                      icon="clear"
                      handler={() => openDeleteModal(true, { ...item })}
                    />
                  </Stack>
                </Stack>
              );
            })
          ) : (
            <Typography>No webhooks</Typography>
          )}
        </Stack>
      </Stack>
    );
  };
  const Schedules = () => {
    const [schedule, setSchedule] = React.useState(false);
    const [openDeleteModal, DeleteModal] = useConfirm({
      title: `Delete Schedule`,
      message: `Are you sure you want to delete this schedule? This action can't be undone.`,
      callback: (props, context) => {
        deleteSchedule(context?.pk);
      },
    });
    if (["auditor"].includes(role)) return null;
    return (
      <Stack p={2}>
        <DeleteModal />
        <Stack p={2}>
          <SidePanel
            width={600}
            open={!!schedule}
            closeDrawer={() => setSchedule(false)}
            props={{ schedule, refresh: getSchedules }}
          >
            {ScheduleEdit}
          </SidePanel>
          {schedules?.length ? (
            (schedules || [])
              ?.sort((a, b) =>
                a.name.toLowerCase().localeCompare(b.name.toLowerCase())
              )
              ?.map((item, index) => {
                return (
                  <Stack
                    key={index}
                    sx={{ width: "98%", margin: "0 auto" }}
                    direction="row"
                    alignItems={"center"}
                    p={2}
                    className="floating"
                  >
                    <Stack sx={{ width: "100%" }}>
                      <Stack alignItems={"center"} direction="row" gap={1}>
                        <Switch
                          disabled
                          checked={item.enabled}
                          // onChange={() => {
                          //   setLimit(!limit);
                          //   setOrder("");
                          //   setLimitCount("");
                          // }}
                        />
                        <Typography>
                          {item.content.name.split("_").at(-1)}
                        </Typography>
                      </Stack>
                      <Stack gap={1}>
                        <Typography variant="caption">
                          {/* {item.content.cron} */}
                        </Typography>

                        <Typography variant="caption">
                          <strong
                            style={{ marginRight: "10px" }}
                          >{`Next Run:`}</strong>
                          {item?.content?.cron?.frequency === "once"
                            ? new Date(
                                item?.content?.cron?.expression
                              )?.toLocaleString()
                            : awsCron
                                .next(
                                  awsCron.parse(
                                    item?.content?.cron?.expression
                                  ),
                                  new Date()
                                )
                                ?.toLocaleString() || "Invalid Cron"}
                        </Typography>
                      </Stack>
                    </Stack>
                    <Stack direction="row" gap={1}>
                      <ActionButton
                        noload
                        circle
                        icon="edit"
                        handler={() => {
                          setSchedule(item);
                        }}
                      />
                      <ActionButton
                        danger
                        noload
                        circle
                        icon="clear"
                        handler={() => openDeleteModal(true, { ...item })}
                      />
                    </Stack>
                  </Stack>
                );
              })
          ) : (
            <Typography>No schedules</Typography>
          )}
        </Stack>
      </Stack>
    );
  };
  const Queue = () => {
    const [log, setLog] = React.useState(null);
    return (
      <Stack p={2}>
        <SidePanel
          width={600}
          open={!!log}
          closeDrawer={() => setLog(null)}
          props={{
            event: { name: log?.name, key: log?.path },
          }}
        >
          {Log}
        </SidePanel>
        {data?.length ? (
          (data || [])
            .sort((a, b) => {
              // Convert the date strings into Date objects
              const dateA = new Date(getUserFriendlyDate(a?.start));
              const dateB = new Date(getUserFriendlyDate(b?.start));

              // Compare the dates
              return dateB - dateA; // For descending order (most current to historical)
            })
            .map((item, index) => {
              return (
                <Stack
                  key={index}
                  sx={{ width: "98%", margin: "0 auto" }}
                  direction="row"
                  alignItems={"center"}
                  p={2}
                  className="floating"
                >
                  <Stack sx={{ width: "100%" }}>
                    <Stack direction="row" gap={1}>
                      <Icon>{Status[item.status]}</Icon>
                      <Typography>{item.name.split("_").at(-1)}</Typography>
                    </Stack>
                    <Stack direction="row" gap={1}>
                      <Typography variant="caption">
                        {item?.start ? getUserFriendlyDate(item?.start) : ""}
                      </Typography>
                      <Typography variant="caption">-</Typography>
                      <Typography variant="caption">
                        {item?.end ? getUserFriendlyDate(item?.end) : ""}
                      </Typography>
                    </Stack>
                  </Stack>
                  <ActionButton
                    noload
                    circle
                    icon="sms"
                    handler={() => setLog(item)}
                  />
                </Stack>
              );
            })
        ) : (
          <Typography>No jobs</Typography>
        )}
      </Stack>
    );
  };
  return (
    <SidePanel
      width={600}
      open={open}
      closeDrawer={() => setOpen(null)}
      props={{}}
    >
      {({ handleClose }) => {
        return (
          <Stack p={2}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              spacing={1}
            >
              <Tabs value={view} onChange={(e, value) => setView(value)}>
                <Tab
                  label={
                    <Stack direction="row" gap={1}>
                      <Icon>pending</Icon>
                      <Typography>Queue</Typography>
                    </Stack>
                  }
                />
                {!["auditor"].includes(role) ? (
                  <Tab
                    label={
                      <Stack direction="row" gap={1}>
                        <Icon>schedule</Icon>
                        <Typography>Schedules</Typography>
                      </Stack>
                    }
                  />
                ) : null}
                {!["operator", "auditor"].includes(role) ? (
                  <Tab
                    label={
                      <Stack direction="row" gap={1}>
                        <Icon>webhooks</Icon>
                        <Typography>Webhooks</Typography>
                      </Stack>
                    }
                  />
                ) : null}
              </Tabs>

              <IconButton
                key="refresh"
                onClick={
                  view === 0 ? getJobs : view === 1 ? getSchedules : getHooks
                }
                color="secondary"
              >
                <Icon color="secondary">refresh</Icon>
              </IconButton>
            </Stack>
            {loading ? (
              <div style={{ padding: "50px", position: "relative" }}>
                <MiniLoader />
              </div>
            ) : null}
            {view === 2 && !loading ? <Webhooks /> : null}
            {view === 1 && !loading ? <Schedules /> : null}
            {view === 0 && !loading ? <Queue /> : null}
          </Stack>
        );
      }
      // !job ? (
      //   <>
      //     <DeleteModal />
      //     <TableView />
      //   </>
      // ) : (
      //   <JobView />
      // )
      }
    </SidePanel>
    // <Modal
    //   width={1000}
    //   forceOpen={!!open}
    //   onClose={() => {
    //     setOpen(false);
    //     setData([]);
    //     setJob(null);
    //   }}
    // >

    // </Modal>
  );
}
export function ActivitySidePanel({ open, setOpen, role }) {
  if (open?.type === "log") {
    return (
      <SidePanel
        width={600}
        open={open?.item}
        closeDrawer={() => setOpen(null)}
        props={{
          event: { name: open?.item?.content?.name, key: open?.item?.path },
        }}
      >
        {Log}
      </SidePanel>
    );
  }
  if (open?.type === "schedule") {
    return (
      <>
        <Stack p={2}>
          <SidePanel
            width={600}
            open={true}
            closeDrawer={() => setOpen(false)}
            props={{ schedule: open?.item, refresh: open?.refresh }}
          >
            {ScheduleEdit}
          </SidePanel>
        </Stack>
      </>
    );
  }
  if (open?.type === "webhook") {
    return (
      <SidePanel
        width={600}
        open={true}
        closeDrawer={() => setOpen(false)}
        props={{ hook: open?.item, system: open?.item?.data?.split("#")[1] }}
      >
        {WebhookView}
      </SidePanel>
    );
  }
  return null;
}
